import './totals.css';

import VerticalBar from '../../verticalBar/verticalBar';

export default function Totals({analyticsTime, filteredExpenses, filteredCategories}) {

    const totalAmountExpense = (filteredExpenses?.[analyticsTime]?.reduce((sum, current) => sum + current?.expense_amount, 0).toFixed(2));

    const totalExpensesEntered = (filteredExpenses?.[analyticsTime]?.length || 0)

    const totalExpenseCategories = (filteredCategories?.[analyticsTime]?.length || 0)

    return (
        <div className="totals">
            <div className="totals-container card">
                <div className="totals-content">
                    <p>Total Expenses:</p>
                    <p><strong>${totalAmountExpense}</strong></p>     
                </div>
                
                <div className="totals-content-bar">
                    <VerticalBar height="5.5rem"/>
                    <div className="totals-content">
                        <p>Total Expenses Entered:</p>
                        <p><strong>{totalExpensesEntered}</strong></p>
                    </div>
                </div>
                
                <div className="totals-content-bar">
                    <VerticalBar height="5.5rem"/>
                        <div className="totals-content">
                            <p>Total Categories:</p>
                            <p><strong>{totalExpenseCategories}</strong></p>
                        </div>
                </div>
             </div>
        </div>
    )
}